export const apiRoot = window.apiRoot || "http://api.shuyuan99.com/";
